/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    assetState: {
      state: null,
      state_label: null,
      color: null,
      version: null,
      withCounterparty: false,
    },
  },

  mutations: {
    asset_state_updated(state, element) {
      state.assetState = element;
    },
  },

  actions: {
    assetStateUpdated({
      commit,
    }, element) {
      return new Promise((resolve, reject) => {
        try {
          commit('asset_state_updated', element);
        } catch (err) {
          reject(err);
        }
      });
    },
  },
});
